module.exports = __webpack_public_path__ + "img/vue-wordpress-sitting-in-a-tree.jpg";